'use client'

import { useEffect, useState } from 'react'
import { Text } from 'ui/src/components/Text/Text'
import { useHighlightAnimation } from 'ui/src/utils/useHighlightAnimation'
import { copyTrigger, slimText } from './CopyToClipboard.css'

type CopyToClipboardProps = {
  label: string
  children: string
}

export function CopyToClipboard({ label, children }: CopyToClipboardProps) {
  const { highlight, animationProps } = useHighlightAnimation<HTMLButtonElement>()
  const [copied, setCopied] = useState(false)

  const copy = () => {
    navigator.clipboard.writeText(children)
    setCopied(true)
    highlight()
  }

  useEffect(() => {
    if (copied) {
      const timeout = setTimeout(() => {
        setCopied(false)
      }, 5000)

      return () => clearTimeout(timeout)
    }
  }, [copied])

  return (
    <button type="button" onClick={copy} className={copyTrigger} {...animationProps}>
      <Text as="p" size="sm" color="textSecondaryOnGray" className={slimText}>
        {label}
      </Text>

      <Text as="p" size="lg" singleLine>
        {children}
      </Text>
    </button>
  )
}
